var _path, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManualOtherIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10742 9.04004H23.8926C24.4433 9.04077 24.9709 9.25999 25.3604 9.64941C25.7498 10.0388 25.969 10.5665 25.9697 11.1172V21.0498C25.9697 21.6007 25.7509 22.129 25.3613 22.5186C24.9718 22.9081 24.4435 23.127 23.8926 23.127H8.10742C7.55653 23.127 7.02824 22.9081 6.63867 22.5186C6.24913 22.129 6.03031 21.6007 6.03027 21.0498V11.1172C6.03101 10.5665 6.25022 10.0388 6.63965 9.64941C7.02907 9.25999 7.55669 9.04077 8.10742 9.04004ZM8.10742 10.3848C7.91343 10.3855 7.72701 10.4624 7.58984 10.5996C7.45267 10.7368 7.37577 10.9232 7.375 11.1172V21.0498C7.37504 21.244 7.45252 21.4301 7.58984 21.5674C7.72719 21.7047 7.91322 21.7822 8.10742 21.7822H23.8926C24.0868 21.7822 24.2728 21.7047 24.4102 21.5674C24.5475 21.4301 24.625 21.244 24.625 21.0498V11.1172C24.6242 10.9232 24.5473 10.7368 24.4102 10.5996C24.273 10.4624 24.0866 10.3855 23.8926 10.3848H8.10742Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.06
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 16.0098,
    r: 1,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.0098,
    r: 1,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 16.0098,
    r: 1,
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualOtherIcon);
export default __webpack_public_path__ + "static/media/ManualOtherIcon.49ae81b1817366c4f047a2e223d6e8d7.svg";
export { ForwardRef as ReactComponent };